import React from "react"

const normalizeErrors = (error) => {
  if (!error) return []
  if (Array.isArray(error)) return error
  if (typeof error === "string") return [error]

  // kalau error object (mis: { message: "..." } atau { field: ["..."] })
  if (typeof error === "object") {
    if (Array.isArray(error.message)) return error.message
    if (typeof error.message === "string") return [error.message]
    return Object.values(error).flat().filter(Boolean).map(String)
  }

  return [String(error)]
}

export default function ErrorMessage({ error }) {
  const errors = normalizeErrors(error)
  if (!errors.length) return null

  return (
    <div className="mt-1 space-y-1">
      {errors.map((row, index) => (
        <p key={index} className="text-xs text-red-600">
          {row}
        </p>
      ))}
    </div>
  )
}